export const ROLES_SERVICE_REQUEST_PARAM = 'x-resource-name=roles';
export const PERMISSIONS_SERVICE_REQUEST_PARAM = 'x-resource-name=permissions';
export const config: any = {};
